import React, { useEffect } from "react";
import { Helmet } from 'react-helmet';
import {
  FormGroupStyled,
  DivSubmit,
} from './style';
import * as S from '../style';
import { verificaParametroDaUrl } from "utils/verify-url-params";
import resetPassword from "services/login/redefinir-senha/redefinir-senha";
import ValidationInfo from "components/ChangePassFrm/Validationinfo";
import LoginScreenCarousel from "components/LoginScreenCarousel/login-screen-carousel";
import logo from 'assets/img/logo-fundacred-branco.svg';
import { useLoginContext } from "context/login-context";
import { useResetPasswordContext } from "context/reset-password-context";
import InputResetPassword from "components/InputResetPassword/input-reset-password";
import { EnumScreenName, IErrorMessagePassword } from "models/login";
import { useHistory } from "react-router-dom";
import Loader from 'components/Login/Loader/Loader';
import ButtonLogin from "components/ButtonLogin/ButtonLogin";

const RedefinicaoSenha = () => {

  const history = useHistory();
  const {
    isLoading,
    setIsLoading,
    setErrorMessage,
  } = useLoginContext();

  const {
    isBtnDisabled,
    password,
    validation,
  } = useResetPasswordContext();

  const validationCode = verificaParametroDaUrl("codValidacao")?.split(" ").join("+");

  const redefinePassword = async (event, password) => {
    setIsLoading(true);
    setErrorMessage('');
    event.preventDefault();
    if (validationCode) {
      await resetPassword(validationCode, password)
        .then(() => window.location.href = "/ies/configuracoes/login")
        .catch((error) => {
          if (error?.response?.data.message === 'Não foi possível processar a requisição. Verifique o(s) parâmetro(s): Código de validação expirado.') {
            setErrorMessage(IErrorMessagePassword.ERRO_LINK_EXPIRADO);
          } else {
            setErrorMessage(IErrorMessagePassword.ERRO_SERVICO);
          }
        })
        .finally(() => setIsLoading(false));
    }
  }

  useEffect(() => {
    if (!validationCode) window.location.href = "/ies/configuracoes/login";
  }, [validationCode])

  return (
    <>
      <Helmet>
        <title>Fundacred - Home</title>
      </Helmet>

      <>
        <S.ContainerLeftStyled>
          <S.LogoStyled src={logo} onClick={() => history.push('/login')} />
          <LoginScreenCarousel />
        </S.ContainerLeftStyled>

        <S.ContainerRightStyled screen={EnumScreenName.TELA_REDEFINICAO_SENHA}>

          <FormGroupStyled>
            <S.TitleContainerStyled>
              <S.H1Styled>Redefinir senha</S.H1Styled>
            </S.TitleContainerStyled>

            <InputResetPassword />

            <ValidationInfo validation={validation} responsive />

            <DivSubmit>
              <ButtonLogin
                id='btn-redefinir-senha'
                label='Redefinir'
                onClick={(event) =>
                  redefinePassword(event, password.newPass)
                }
                disabled={isBtnDisabled || isLoading}
                type='with-icon'
                icon={isLoading ? <Loader className='loader' /> : ''}
              />
            </DivSubmit>

          </FormGroupStyled>

        </S.ContainerRightStyled>
      </>
    </>
  )
}

export default RedefinicaoSenha;